<template>
    <div class="col-12 c g">
        <div class="card card-body">
            <h2>
                الفرق بين طرق ارسال والواتساب
            </h2><br>
            <div class="col-12 table-responsive">
                <table class="table table-hover table-bordered">
                    <thead>
                        <th>
                            الطريقة
                        </th>
                        <th>
                            وصفها
                        </th>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                الواتس التلقائي
                            </td>
                            <td>
                                يقوم بارسال الرسائل في الخلفية بدون فتح جهازك او القيام بأي اجراء مثل الرسائل النصية تماماً.
                            </td>
                        </tr>
                        <tr>
                            <td>
                               اداة الواتساب المجانية
                            </td>
                            <td>
                               تقوم بتثبيت اداة على المتصفح وعند الحاجة الى ارسال الرسائل تقوم يدوياً بالضغط على ارسال والانتظار لحين انتهاء الارسال.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                الاداة المتطورة (الواتس المباشر)
                            </td>
                            <td>
                              تقوم بتثبيت اداة على المتصفح وهي تتحكم في المتصفح وعند ارسال اي رسائل من النظام من اي مكان هي تقوم بفتح الواتساب على جهازك وارسال الرسائل بشكل مباشر وتلقائي
                              , <br>
                              فيمكنك فتح جهازك من اي مكان والذهاب لمكان اخر وعند الارسال سيقوم النظام بارسال الرسائل من جهازك بدون الحاجة لأي إجراء منك.
                              <br>
                              فهي مثل الواتس الذكي لكن تتطلب منك ترك جهاز الكمبيوتر مفتوح، واذا كان مغلق عند الارسال فسيبداً الارسال عندما تقوم باعادة فتح الجهاز.
                              <a href="https://youtu.be/rfMfpDu15vE" class="btn btn-sm btn-danger" target="_blank">شاهد الشرح</a>
                            </td>
                        </tr>
                    </tbody>
                </table><br>
                <div class="col-12 text-center g">
                    <h4>
                        لأي استفاسارات تواصل معنا عبر الواتساب
                        <br><br>
                         966580200670
                    </h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>